import { Table } from '@imcva/reactstrap-table'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useLookupOptions } from 'src/queries'
import { columns } from './columns'
import useToggleStateValue from 'src/hooks/useToggleStateValue'
import EditModal from './modals/Edit'
import RelationshipsModal, { RelationshipsModalToggleProps } from './modals/Relationships'

const Body: React.FC = (props) => {
  const id = useParams<{ id: string }>().id
  if (id === undefined) {
    return null
  }
  const options = useLookupOptions(id)
  const { value: editModelValue, toggle: toggleEditModal } = useToggleStateValue<string>()
  const { value: relationshipModel, toggle: toggleRelationshipModal } = useToggleStateValue<RelationshipsModalToggleProps>()

  return (
    <>
      <Table
        storageKey='lookup-options-table'
        options={{
          data: options,
          columns: columns(toggleEditModal, toggleRelationshipModal),
          initialState: { sorting: [{ id: 'name', desc: false }] }
        }}
      />
      <EditModal toggle={toggleEditModal} id={editModelValue} lookupId={id} />
      <RelationshipsModal
        toggle={toggleRelationshipModal}
        lookupId={id}
        optionId={relationshipModel?.optionId}
        relationshipModel={relationshipModel?.relationshipModel}
      />
    </>
  )
}

export default Body
